
export default class UserUtils {

  // static Roles = {
  //   admin: 1,
  //   orgAdmin: 2,
  //   powerUser: 3,
  //   standard: 4
  // }

  static UserStatuses = ['Registered', 'Invited', 'Joined'];

  static GetStatus = (user) => {
    if (user.userStatus === null || user.userStatus > this.UserStatuses.length) {
      return this.UserStatuses[0]
    }else {
      return this.UserStatuses[user.userStatus];
    }
  }

  static RoleObjects = {
    admin: {name: "admin", value: 1},
    orgAdmin: {name: "orgAdmin", value: 2},
    powerUser: {name: "powerUser", value: 3},
    standard: {name: "standard", value: 4}
  }

  static GetHighestRoleString = (user) => {
    let roleValues = this.GetRoleValues(user).sort((a, b) => a-b);
    if (roleValues.length === 0){
      return "";
    }
    let roleObj = this.RoleValueToObject(roleValues[0]);
    return this.RoleObjToRoleString(roleObj);

  }

  static GetHighestRoleObj = (user) => {
    let roleValues = this.GetRoleValues(user).sort((a, b) => a-b);
    if (roleValues.length === 0){
      return "";
    }
    let roleObj = this.RoleValueToObject(roleValues[0]);
    return roleObj

  }

  static RoleObjToRoleString = (obj) => {
    switch (obj?.name){
      case "admin":
        return "Admin";
      case "orgAdmin":
        return "Org Admin";
      case "powerUser":
        return "Power User";
      case "standard":
        return "Standard";
      default:
        return "";
    }
  }

  static RoleValueToObject = (roleValue) => {
    let roleObject = null;
    this.RoleNames.forEach(name => {
      if (this.RoleObjects[name]?.value === roleValue){
        roleObject = this.RoleObjects[name];
      }
    });
    return roleObject;
  }

  static GetRoleValues = (user) => {
    let roles = user.userRoles;
    if (!Array.isArray(roles) || roles.length === 0){
      return [];
    }
    let roleValues = [];
    roles.forEach(x => {
      if (x.roleNavigation && x.roleNavigation.roleType){
        roleValues.push(x.roleNavigation.roleType);
      }
    });
    return roleValues;
  }

  static checkIfUserHasRole = (user, role) => {
    if (UserUtils.RoleObjects[role]){
      let roleObject = UserUtils.RoleObjects[role];
      let roleValues = UserUtils.GetRoleValues(user);
      //if the users role value is <= the request level we good (admin most powerful, descending power)
      let foundRole = (roleValues.findIndex(rv => rv <= roleObject.value) > -1) //findIndex returns -1 if no match, so if returns > -1 we all good 
      return foundRole;
    }
    return false;
  }

  static RoleNames = Object.keys(UserUtils.RoleObjects);
}



